<template>
  <base-firebase-list
    :items-getter="'getAlertHistory'"
    :items-paginator="'paginateAlerts'"
  >
    <template v-slot:row="{ items }">
      <template v-for="(item, index) in items">
        <v-list-item>
          <v-list-item-avatar>
            <v-icon
              right
              class="primary--text"
            >
              notifications_none
            </v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
            <v-list-item-subtitle>{{ item.body }}</v-list-item-subtitle>
            <v-list-item-subtitle class="caption grey--text" >{{ formatDate(item.createdAt.toDate()) }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider />
      </template>
    </template>
  </base-firebase-list>
</template>
<script>
import moment from 'moment'
import BaseFirebaseList from '@/components/Common/BaseFirebaseList'

export default {
  components: {
    BaseFirebaseList
  },
  methods: {
    formatDate(date) {
      return moment(date).format('LLL')
    }
  }
}
</script>
